import { render, staticRenderFns } from "./STYJ.vue?vue&type=template&id=5ced1fa4&scoped=true&"
import script from "./STYJ.vue?vue&type=script&lang=js&"
export * from "./STYJ.vue?vue&type=script&lang=js&"
import style0 from "./STYJ.vue?vue&type=style&index=0&id=5ced1fa4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced1fa4",
  null
  
)

export default component.exports